import { useIntl } from "react-intl";
import { DataTable, type DataTableProps } from "@wayflyer/flyui-dataviz";
import { Flex, MarkDown, Text } from "@wayflyer/flyui";

import { TabTitle } from "../../../../components/tab-title";
import { belowCacBackground, ltvBackgrounds, type LtvRow } from "../../heatmap";

export interface ConsumersLtvTabProps {
  summaryText?: string;
  table: Pick<DataTableProps<LtvRow>, "columns" | "data" | "title">;
  title: string;
  tooltip?: string;
}

const LTVLegend = () => {
  const intl = useIntl();
  return (
    <Flex wrap="wrap" align="center" gap="6">
      <Flex align="center" gap="2">
        <Text size="sm">
          {intl.formatMessage({ id: "Consumers LTV Tab: Legend Lower value", defaultMessage: "Lower value" })}
        </Text>
        <Flex gap="var(--sizes-spacing-0-5)">
          {ltvBackgrounds.map((background) => (
            <Flex
              key={background}
              width="var(--sizes-spacing-6)"
              height="var(--sizes-spacing-5)"
              backgroundColor={background}
            />
          ))}
        </Flex>
        <Text size="sm">
          {intl.formatMessage({ id: "Consumers LTV Tab: Legend Higher value", defaultMessage: "Higher value" })}
        </Text>
      </Flex>
      <Flex align="center" gap="2">
        <Flex width="var(--sizes-spacing-6)" height="var(--sizes-spacing-5)" backgroundColor={belowCacBackground} />
        <Text size="sm">
          {intl.formatMessage({
            id: "Consumers LTV Tab: Customer value at or below CAC",
            defaultMessage: "Customer value at or below CAC",
          })}
        </Text>
      </Flex>
    </Flex>
  );
};

export const ConsumersLtvTab = ({ summaryText, table, title, tooltip }: ConsumersLtvTabProps): UIElement => (
  <Flex direction="column" gap="6" minWidth="0">
    <TabTitle title={title} tooltip={tooltip} />
    {summaryText ? <MarkDown markdown={summaryText} /> : null}
    <DataTable
      {...table}
      getRowId={(row) => String(row.fcp)}
      pinLeftColCount={3}
      rowHeight="var(--sizes-spacing-10)"
      controlOptions={{ hidePagination: true }}
    />
    <LTVLegend />
  </Flex>
);
